module.exports = __webpack_public_path__ + "img/500px-white.f6061ab0.svg";